/** Номер чека - как ввели или отсканировали, без пробелов по краям; пустой номер не открывает окно возврата. */
export function normalizeReceiptNumber(raw: string): string {
  return raw.trim()
}
